import { useState } from 'react';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import CustomInput from '@/components/CustomInput/CustomInput';
import { useTranslation } from 'react-i18next';
import Button from '@/components/CustomButtons/Button';
import CountryDropdown from '@/components/CountryDropdown';

const NaupaContactForm = ({ id, naupaContact, setNaupaContact }) => {
  const { t } = useTranslation();
  const handleNaupaContactChange = (e) => {
    setNaupaContact({ ...naupaContact, [e.target.name]: e.target.value });
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactNameLabel', { id })}
          id={`naupaContact${id}Name`}
          name='name'
          onChange={handleNaupaContactChange}
          value={naupaContact.name}
          type='text'
          maxLength={40}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactAddress1Label', {
            id,
          })}
          id={`naupaContact${id}Address1`}
          name='address1'
          onChange={handleNaupaContactChange}
          value={naupaContact.address1}
          type='text'
          maxLength={30}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactAddress2Label', {
            id,
          })}
          id={`naupaContact${id}Address2`}
          name='address2'
          onChange={handleNaupaContactChange}
          value={naupaContact.address2}
          type='text'
          maxLength={30}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      {'address3' in naupaContact && (
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText={t('organizations.update.naupaContactAddress3Label', {
              id,
            })}
            id={`naupaContact${id}Address3`}
            name='address3'
            onChange={handleNaupaContactChange}
            value={naupaContact.address3}
            type='text'
            maxLength={30}
            formControlProps={{ fullWidth: true }}
          />
        </GridItem>
      )}
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactCityLabel', { id })}
          id={`naupaContact${id}City`}
          name='city'
          onChange={handleNaupaContactChange}
          value={naupaContact.city}
          type='text'
          maxLength={30}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactStateLabel', { id })}
          id={`naupaContact${id}State`}
          name='state'
          onChange={handleNaupaContactChange}
          value={naupaContact.state}
          type='text'
          maxLength={2}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactZipCodeLabel', { id })}
          id={`naupaContact${id}ZipCode`}
          name='zipCode'
          onChange={handleNaupaContactChange}
          value={naupaContact.zipCode}
          type='text'
          maxLength={9}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CountryDropdown
          id={`naupaContact${id}Country`}
          labelText={t('organizations.update.naupaContactCountryLabel', { id })}
          value={naupaContact.country}
          onChange={handleNaupaContactChange}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactAreaCodeLabel', {
            id,
          })}
          id={`naupaContact${id}AreaCode`}
          name='areaCode'
          onChange={handleNaupaContactChange}
          value={naupaContact.areaCode}
          type='text'
          maxLength={3}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactTelNumberLabel', {
            id,
          })}
          id={`naupaContact${id}TelNumber`}
          name='telNumber'
          onChange={handleNaupaContactChange}
          value={naupaContact.telNumber}
          type='text'
          maxLength={7}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactTelExtensionLabel', {
            id,
          })}
          id={`naupaContact${id}TelExtension`}
          name='telExtension'
          onChange={handleNaupaContactChange}
          value={naupaContact.telExtension}
          type='text'
          maxLength={4}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <CustomInput
          labelText={t('organizations.update.naupaContactEmailLabel', { id })}
          id={`naupaContact${id}Email`}
          name='email'
          onChange={handleNaupaContactChange}
          value={naupaContact.email}
          type='text'
          maxLength={50}
          formControlProps={{ fullWidth: true }}
        />
      </GridItem>
    </GridContainer>
  );
};

const NaupaInfoTab = ({ organization, updateOrganization }) => {
  const { t } = useTranslation();
  const [naupaContact1, setNaupaContact1] = useState({
    name: organization.naupa_contact_1_name || '',
    address1: organization.naupa_contact_1_address_1 || '',
    address2: organization.naupa_contact_1_address_2 || '',
    city: organization.naupa_contact_1_city || '',
    state: organization.naupa_contact_1_state || '',
    zipCode: organization.naupa_contact_1_zip_code || '',
    country: organization.naupa_contact_1_country || '',
    areaCode: organization.naupa_contact_1_area_code || '',
    telNumber: organization.naupa_contact_1_tel_number || '',
    telExtension: organization.naupa_contact_1_tel_extension || '',
    email: organization.naupa_contact_1_email || '',
  });
  const [naupaContact2, setNaupaContact2] = useState({
    name: organization.naupa_contact_2_name || '',
    address1: organization.naupa_contact_2_address_1 || '',
    address2: organization.naupa_contact_2_address_2 || '',
    address3: organization.naupa_contact_2_address_3 || '',
    city: organization.naupa_contact_2_city || '',
    state: organization.naupa_contact_2_state || '',
    zipCode: organization.naupa_contact_2_zip_code || '',
    country: organization.naupa_contact_2_country || '',
    areaCode: organization.naupa_contact_2_area_code || '',
    telNumber: organization.naupa_contact_2_tel_number || '',
    telExtension: organization.naupa_contact_2_tel_extension || '',
    email: organization.naupa_contact_2_email || '',
  });
  const [faxAreaCode, setFaxAreaCode] = useState(
    organization.naupa_fax_area_code || '',
  );
  const [faxNumber, setFaxNumber] = useState(
    organization.naupa_fax_number || '',
  );
  const handleFaxAreaCode = (e) => setFaxAreaCode(e.target.value);
  const handleFaxNumber = (e) => setFaxNumber(e.target.value);
  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append('naupa_fax_area_code', faxAreaCode);
    formData.append('naupa_fax_number', faxNumber);
    formData.append('naupa_contact_1_name', naupaContact1.name);
    formData.append('naupa_contact_1_address_1', naupaContact1.address1);
    formData.append('naupa_contact_1_address_2', naupaContact1.address2);
    formData.append('naupa_contact_1_city', naupaContact1.city);
    formData.append('naupa_contact_1_state', naupaContact1.state);
    formData.append('naupa_contact_1_zip_code', naupaContact1.zipCode);
    formData.append('naupa_contact_1_country', naupaContact1.country);
    formData.append('naupa_contact_1_area_code', naupaContact1.areaCode);
    formData.append('naupa_contact_1_tel_number', naupaContact1.telNumber);
    formData.append(
      'naupa_contact_1_tel_extension',
      naupaContact1.telExtension,
    );
    formData.append('naupa_contact_1_email', naupaContact1.email);
    formData.append('naupa_contact_2_name', naupaContact2.name);
    formData.append('naupa_contact_2_address_1', naupaContact2.address1);
    formData.append('naupa_contact_2_address_2', naupaContact2.address2);
    formData.append('naupa_contact_2_address_3', naupaContact2.address3);
    formData.append('naupa_contact_2_city', naupaContact2.city);
    formData.append('naupa_contact_2_state', naupaContact2.state);
    formData.append('naupa_contact_2_zip_code', naupaContact2.zipCode);
    formData.append('naupa_contact_2_country', naupaContact2.country);
    formData.append('naupa_contact_2_area_code', naupaContact2.areaCode);
    formData.append('naupa_contact_2_tel_number', naupaContact2.telNumber);
    formData.append(
      'naupa_contact_2_tel_extension',
      naupaContact2.telExtension,
    );
    formData.append('naupa_contact_2_email', naupaContact2.email);

    await updateOrganization(formData);
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            type='text'
            labelText={t('organizations.update.faxAreaCodeLabel')}
            onChange={handleFaxAreaCode}
            value={faxAreaCode}
            id='faxAreaCode'
            name='faxAreaCode'
            maxLength={3}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            type='text'
            labelText={t('organizations.update.faxNumberLabel')}
            onChange={handleFaxNumber}
            value={faxNumber}
            id='faxNumber'
            name='faxNumber'
            maxLength={7}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
      </GridContainer>

      <NaupaContactForm
        id={1}
        naupaContact={naupaContact1}
        setNaupaContact={setNaupaContact1}
      />
      <NaupaContactForm
        id={2}
        naupaContact={naupaContact2}
        setNaupaContact={setNaupaContact2}
      />
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Button color='primary' onClick={handleUpdate}>
            {t('common.buttons.update')}
          </Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}></GridItem>
      </GridContainer>
    </>
  );
};

export default NaupaInfoTab;
